exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-shop-product .page-section.page-shop-collection{background:none!important;margin:0!important}", ""]);

// exports
